module.exports = __webpack_public_path__ + "img/lable_title_jp.ece0f86e.svg";